import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { PreservingNavLink } from "@components/common/preserve-navigation/preserving-nav-link";
import { AnalyticsFeedbackDialog } from "@components/analytics/in-house/feedback/analytics-feedback-dialog";
import { shouldShowAnalyticsFeedback } from "@components/analytics/in-house/feedback/analytics-feedback-storage";
import { SdbCompanyMenu } from "@components/sidebar/sdb-company/sdb-company-menu";
import { SidebarHolobuilderItem } from "@components/sidebar/sidebar-holobuilder/sidebar-holobuilder-item";
import { SidebarItems } from "@components/sidebar/sidebar-items";
import { SidebarList } from "@components/sidebar/sidebar-list";
import { SidebarRouteExitDialog } from "@components/sidebar/sidebar-route-exit-dialog";
import { SidebarSwitchToLegacyUI } from "@components/sidebar/sidebar-switch-to-legacy-ui";
import { TrialCountdown } from "@components/sidebar/trial-countdown/trial-countdown";
import { Box } from "@mui-wrapper";
import { MainRoutes } from "@router/route-params";
import { useAppDispatch } from "@store/store-helper";
import { updateSidebar } from "@store/ui/ui-slice";
import { CollapseArrowIcon, ExpandArrowIcon, ListItem, SphereXgLogo } from "@flat-ui";
import { CommonStyles } from "@styles/common-styles";
import { SidebarEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useMemo } from "react";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
export function SidebarContent(t0) {
  const $ = _c(35);
  const {
    isSidebarFullSize,
    isSidebarMobileVersion
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  const {
    canViewPremiumAnalytics,
    isHbToSxgMigrated
  } = useHasUserValidFeatureCompanyLevel();
  const logoSize = isSidebarMobileVersion ? "3rem" : "3.25rem";
  const t1 = isSidebarFullSize ? "0.625rem" : "0.438rem";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      pb: "0.25rem",
      pt: "0.375rem",
      pl: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== trackEvent) {
    t3 = () => {
      trackEvent({
        name: SidebarEvents.goHome
      });
    };
    $[2] = trackEvent;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isSidebarFullSize ? "full" : "mini";
  let t5;
  if ($[4] !== logoSize || $[5] !== t4) {
    t5 = <SphereXgLogo variant={t4} height={logoSize} />;
    $[4] = logoSize;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <PreservingNavLink to={MainRoutes.projects}><Box component="div" sx={t2} onClick={t3}>{t5}</Box></PreservingNavLink>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SdbCompanyMenu />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isSidebarFullSize) {
    t8 = <SidebarList isSidebarFullSize={isSidebarFullSize} sidebarItems={SidebarItems} />;
    $[12] = isSidebarFullSize;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div>{t6}{t7}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== canViewPremiumAnalytics) {
    t10 = canViewPremiumAnalytics && <SidebarRouteExitDialog route={MainRoutes.analytics} canOpen={shouldShowAnalyticsFeedback} renderDialog={_temp} />;
    $[17] = canViewPremiumAnalytics;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <TrialCountdown />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isHbToSxgMigrated || $[21] !== isSidebarFullSize) {
    t12 = isHbToSxgMigrated ? <SidebarSwitchToLegacyUI isSidebarFullSize={isSidebarFullSize} /> : <SidebarHolobuilderItem isSidebarFullSize={isSidebarFullSize} />;
    $[20] = isHbToSxgMigrated;
    $[21] = isSidebarFullSize;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== dispatch || $[24] !== isSidebarFullSize || $[25] !== isSidebarMobileVersion || $[26] !== trackEvent) {
    t13 = !isSidebarMobileVersion && <ListItem sx={{
      width: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: isSidebarFullSize ? "flex-end" : "center",
      borderTop: CommonStyles.Borders.divider,
      color: "text.primary",
      minHeight: "64px"
    }}><SphereIconButton dataTestId="SIDEBAR_TOGGLE_BUTTON" component={isSidebarFullSize ? CollapseArrowIcon : ExpandArrowIcon} onClick={() => {
        trackEvent({
          name: isSidebarFullSize ? SidebarEvents.collapse : SidebarEvents.expand
        });
        dispatch(updateSidebar({
          isFullSize: !isSidebarFullSize
        }));
      }} /></ListItem>;
    $[23] = dispatch;
    $[24] = isSidebarFullSize;
    $[25] = isSidebarMobileVersion;
    $[26] = trackEvent;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div>{t11}{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t10 || $[32] !== t14 || $[33] !== t9) {
    t15 = <>{t9}{t10}{t14}</>;
    $[31] = t10;
    $[32] = t14;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
function _temp(close) {
  return <AnalyticsFeedbackDialog onClose={close} />;
}